module.exports = __webpack_public_path__ + "static/img/day4.f72e733.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/day4.jpg
// module id = t/d8
// module chunks = 0